// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__ATgtb","file":"styles_file__2aaAZ"};